import { getClass } from '$lib/api/studentActions';
import { error } from '@sveltejs/kit';
import type { LayoutLoad } from './$types';

export const load: LayoutLoad = ({ params, fetch }) => {
  const id = parseInt(params.id);
  if (isNaN(id)) error(404);
  const classPromise = getClass(id, fetch);
  return {
    classPromise,
    meta: {
      title: 'Classes',
      breadcrumbs: {
        activeTitle: classPromise.then(x => x.class.name),
        items: [
          {
            title: 'Classes',
            href: '/classes',
          },
        ],
      },
    },
  };
};
